var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-menu',{attrs:{"collapsed":_vm.sidebarCollapsed,"menu":_vm.currentMenus,"theme":_vm.navTheme,"mode":_vm.mode},on:{"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }